import axios from "axios";

const API_URL = "https://gpro_api.gpro-ks.com/api/";


export default {

  getBlogs3() {
    return axios.get(
        API_URL + "blogs3.php"
    );
  },

  getBlogs() {
    return axios.get(
        API_URL + "blogs.php"
    );
  },

  getBlog(slug) {
    return axios.get(
      API_URL + "blog.php",
      {
        params:{
            slug: slug
        }
      }
    );
  },

  getClients(){
    return axios.get(
        API_URL + "clients.php"
    );
  },


  sendMail(form) {
    return axios.post(
        API_URL + "sendMail.php",
        form
    );
  }


};